// PrivateRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { Spinner } from "reactstrap";
import { useAuth } from "./AuthContext";
import { useFetchCompanyUserDataQuery } from "../api/usersApi";
import { useTranslation } from "../hooks/useTranslation";

const PrivateRoute = ({ element, roles }) => {
  const { token, loading } = useAuth();
  const t = useTranslation();
  const user = useFetchCompanyUserDataQuery(undefined, { skip: !token || !roles?.length });

  if (loading || (token && roles?.length && user.isLoading)) {
    return (
      <div className="content text-center py-5">
        <Spinner size="sm" color="primary" />
        <span className="ml-2">{t("common.loading")}</span>
      </div>
    );
  }

  if (token && roles?.length) {
    const role = String(user.data?.user?.role || "").toLowerCase();
    if (user.isError || !roles.includes(role)) {
      return <div className="content" role="alert">{t("analytics.restrictedTitle")}</div>;
    }
  }

  return token ? element : <Navigate to="/admin/login" replace />;
};

export default PrivateRoute;
